import React, { useState } from 'react';
import './SolutionCard.scss';
import Arrow from '../../../Icons/Arrow';
import { COLORS } from '../../../../../constants/colors';

/**
 * Renders a custom variant of a card UI used in the solutions component on homepage
 * @param title {String} - Card title
 * @param desc {String} - Card description
 * @param link {String} - Card link
 * @param hoverImage {Object} - Image to be shown when the user hovers over the card
 * @param quote {String} - Quote that goes under the card
 * @param quoteAuthor {String} - Quote Author
 * @returns {JSX.Element}
 * @constructor
 */
const SolutionCard = ({ title, desc, link, hoverImage, quote, quoteAuthor }) => {
  const [isHovering, setIsHovering] = useState(false);

  const toggleBackground = () => setIsHovering(!isHovering);

  return (
    <div className="c-solution-card">
      <a href={link} className="c-solution-card__link">
        <div
          className="c-solution-card__content-wrapper"
          style={{
            backgroundImage: `url(${isHovering ? hoverImage.url : ''})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
          onMouseEnter={toggleBackground}
          onMouseLeave={toggleBackground}
        >
          {isHovering ? <div className="dark-overlay" /> : null}

          <div className="c-solution-card__content">
            <h4
              className={`c-solution-card__heading h3-roobert ${
                isHovering ? 'color-white' : 'color-black'
              }`}
            >
              {title}
            </h4>
            <p
              className={`c-solution-card__desc body-1 ${
                isHovering ? 'color-white' : 'color-black'
              }`}
            >
              {desc}
            </p>
          </div>

          <div className="c-solution-card__arrow">
            <Arrow color={isHovering ? COLORS.white : COLORS.black} />
          </div>
        </div>
      </a>

      <div className="c-solution-card__quote">
        <span className="c-solution-card__quote-text color-black body-2">"{quote}"</span>
        <span className="c-solution-card__quote-author color-black eyebrow-2">
          —<br />
          {quoteAuthor}
        </span>
      </div>
    </div>
  );
};

export default SolutionCard;
